import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_3008_6561)\"><path d=\"M1.30469 8.61426C1.30469 10.4708 2.04219 12.2513 3.35494 13.564C4.6677 14.8768 6.44817 15.6143 8.30469 15.6143C10.1612 15.6143 11.9417 14.8768 13.2545 13.564C14.5672 12.2513 15.3047 10.4708 15.3047 8.61426C15.3047 6.75774 14.5672 4.97727 13.2545 3.66451C11.9417 2.35176 10.1612 1.61426 8.30469 1.61426C6.44817 1.61426 4.6677 2.35176 3.35494 3.66451C2.04219 4.97727 1.30469 6.75774 1.30469 8.61426Z\" stroke=\"#454342\"></path><path d=\"M4.97266 8.56068L7.27151 10.6974L11.6393 6.53076\" stroke=\"#454342\" stroke-miterlimit=\"10\" stroke-linecap=\"square\"></path></g><defs><clipPath id=\"clip0_3008_6561\"><rect width=\"16\" height=\"16\" fill=\"white\" transform=\"translate(0.304688 0.614258)\"></rect></clipPath></defs>", 2)
  ])))
}
export default { render: render }